/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const quickOrderCartForm = {
  entriesWereAgregared: '({{{ quantity }}) {{ product }} se ha añadido al carrito',
  entryWasAgregared: '{{{ product }} se ha añadido al carrito',
  noResults: 'No pudimos encontrar ningún producto',
  stockLevelReached: 'Se ha alcanzado el nivel máximo de existencias',
  title: 'Pedido rápido',
  productCodePlaceholder: 'Introduzca el IDENTIFICACIÓN',
  entryProductoCode: 'Introduzca el IDENTIFICACIÓN de producto de Pedido rápido',
  quantity: 'Cantidad para pedido rápido',
  addToCart: 'Añadir producto a Pedido rápido',
  add: 'Agregar',
  product: 'Producto',
  products: 'Productos',
  productCodeLabel: 'Producto IDENTIFICACIÓN',
  quantityLabel: 'Cantidad',
};

export const quickOrderForm = {
  placeholder: 'Introduzca el nombre o código del producto',
  searchBoxLabel:
    'Introduzca el nombre o código del producto for quick order. You can add up to {{{ limit }} products per order.',
  listLimitReached: 'Se ha alcanzado el límite de productos.',
  id: 'IDENTIFICACIÓN {{{ id }}',
  noResults: 'No se pudo encontrar ningún resultado',
  addProducto: 'Agregar producto {{{ product }}',
  initialDescription:
    'Cuando los resultados de autocompletar estén disponibles, use las flechas hacia arriba y hacia abajo para revisar e ingresar para seleccionar.',
  productsResults: '{{{ count }} Los productos están disponibles.',
  quickOrderSearch: 'Encuentre el producto para un pedido rápido',
  outOfStockMessage: 'El producto (#{{code}}) se encuentra agotado.',
};

export const quickOrderList = {
  addToCart: 'Agregar al carrito',
  emptyList: 'Lista vacía',
  header: 'Agregar Productos/SKUs',
  subHeader: 'Puedes añadir hasta {{{ limit }} SKU válidos a la vez.',
  errorProceedingToCart: 'Error al proceder al carrito.',
  warningProceedingToCart: 'Advertencia procediendo al carrito.',
  successfullyAgregaredToCart: 'Añadido con éxito al carrito.',
  errors: {
    productIsOutOfStock: '{{{ name }} (#{{code}}) está agotado.',
    reviewErrors: 'Por favor, revise estos errores.',
    listIsFull:
      'La lista está llena, agregue estos {{{ count }} productos al carrito para continuar.',
    nonPurchasableError: 'El producto {{{ name }} no se puede comprar',
    outOfStockErrorFound: '{{{count}} No se ha añadido el producto agotado.',
    outOfStockErrorFound_other:
      '{{{count}} No se agregaron productos agotados.',
  },
  warnings: {
    productWasReduced:
      'La cantidad de {{{ name }} (#{{code}}) se redujo a {{{ quantityAdded}}.',
    reviewWarnings: 'Por favor, revise estas advertencias.',
    reduceWarningFound: '{{{count}} Se redujo la cantidad de producto.',
    reduceWarningFound_other: '{{{count}} Se redujo la cantidad de productos.',
  },
  successes: {
    productAgregaredToCart: '{{{ name }} (#{{code}}) se ha añadido al carrito.',
    addedToCartFound: '{{{ count }} El producto se ha añadido al carrito.',
    addedToCartFound_other: '{{{ count }} Los productos se agregaron al carrito.',
  },
  informations: {
    addProductoBeforeAgregaringToCart:
      'Agregue productos a la lista antes de agregarlos al carrito.',
  },
  undo: 'DESHACER',
  revokeUndo: 'Revoked product "{{name}}" deletion.',
  productWasDeleted: 'Producto "{{ name }}" moved to trash.',
};

export const quickOrderTable = {
  product: 'Producto',
  id: 'IDENTIFICACIÓN',
  price: 'Precio',
  quantity: 'Cantidad',
  itemPrecio: 'Precio del artículo',
  qty: 'Cantidad',
  actions: 'Acciones',
  inStock: 'En stock',
  lowStock: 'Existencias bajas',
  outOfStock: 'Agotado',
  listCleared: 'Se ha borrado la lista de pedidos rápidos',
  addedtoCart: 'Se ha añadido una lista rápida de pedidos al carrito',
  caption: 'Contenido de pedidos rápidos.',
  length: 'Largo (MM)',
  sheetsPerPackage: 'Chapas/Paquete',
  packageWeight: 'Peso del Paquete (KG)',
};

export const quickOrder = {
  quickOrderCartForm,
  quickOrderForm,
  quickOrderList,
  quickOrderTable,
};
